minilog = require('minilog');
minilog.enable();
const log = minilog(__LOGGER_NAME__);
debug = __DEV__ ? log.warn : (()=>{});
error = log.error;
warn = log.warn;
notify = log.warn;
